import { render, staticRenderFns } from "./ServerError.vue?vue&type=template&id=28dd224f&scoped=true&"
import script from "./ServerError.vue?vue&type=script&lang=js&"
export * from "./ServerError.vue?vue&type=script&lang=js&"
import style0 from "./ServerError.vue?vue&type=style&index=0&id=28dd224f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28dd224f",
  null
  
)

export default component.exports